export const locale = {
  title: 'Please select your primary language',
  description:
    'Selecting your primary language helps us provide a better experience during appointments.\n\nThis can be updated in your User Profile & Settings at any time.',
  placeholder: 'Primary Language',
  save: 'Save Primary Language',
};
